// client/src/components/MarkdownRenderer.js
import ReactMarkdown from 'react-markdown';
import rehypeRaw from "rehype-raw";
import remarkGfm from 'remark-gfm';  // ← ADD THIS
import { Box } from '@chakra-ui/react';

export default function MarkdownRenderer({ content }) {
  return (
    <Box
      sx={{
        // Headings
        'h1': {
          fontSize: '22px',
          fontWeight: '700',
          marginBottom: '10px',
          marginTop: '10px',
          color: '#1A202C',
        },
        'h2': {
          fontSize: '20px',
          fontWeight: '700',
          marginBottom: '4px',
          marginTop: '4px',
          color: '#1A202C',
  // letterSpacing: '0.35px',
        },
        'h3': {
          fontSize: '18px',
          fontWeight: '650',
          marginBottom: '3px',
          marginTop: '3px',
          color: '#1A202C',
        },
        'p': {
          marginBottom: '2px',
          lineHeight: '1.7',
          color: '#2D3748',
        },
        'strong': {
          fontWeight: '650',
          color: '#1A202C',
          fontSize: '14px',
        },
        'ul': {
          paddingLeft: '24px',
          marginBottom: '2px',
        },
        'ol': {
          paddingLeft: '24px',
          marginBottom: '2px',
        },
        'li': {
          marginBottom: '2px',
          lineHeight: '1.6',
          color: '#2D3748',
        },
        'ul li::marker': {
          color: '#1A202C',
        },
        'code': {
          backgroundColor: '#F7FAFC',
          padding: '2px 6px',
          borderRadius: '4px',
          fontSize: '0.9em',
          color: '#1A202C',
        },
        'pre': {
          backgroundColor: '#F7FAFC',
          padding: '12px',
          borderRadius: '8px',
          overflow: 'auto',
          marginBottom: '2px',
        },
        // Tables — improved styling
        'table': {
          width: '100%',
          borderCollapse: 'collapse',
          marginBottom: '12px',
          marginTop: '8px',
          fontSize: '14px',
        },
        'thead': {
          backgroundColor: '#F7FAFC',
        },
        'th': {
          backgroundColor: '#EDF2F7',
          padding: '10px 14px',
          textAlign: 'left',
          fontWeight: '650',
          color: '#1A202C',
          borderBottom: '2px solid #CBD5E0',
          borderRight: '1px solid #E2E8F0',
          whiteSpace: 'nowrap',
        },
        'td': {
          padding: '9px 14px',
          borderBottom: '1px solid #E2E8F0',
          borderRight: '1px solid #E2E8F0',
          color: '#2D3748',
          verticalAlign: 'top',
          lineHeight: '1.5',
        },
        'tr:hover': {
          backgroundColor: '#F7FAFC',
        },
        'tr:last-child td': {
          borderBottom: 'none',
        },
        // Blockquotes
        'blockquote': {
          borderLeft: '4px solid #CF008A',
          paddingLeft: '16px',
          marginLeft: '0',
          marginBottom: '4px',
          color: '#4A5568',
          fontStyle: 'italic',
        },
        'hr': {
          border: 'none',
          borderTop: '1px solid #E2E8F0',
          marginTop: '20px',
          marginBottom: '20px',
        },
      }}
    >
      <ReactMarkdown
        rehypePlugins={[rehypeRaw]}
        remarkPlugins={[remarkGfm]}  
      >
        {content}
      </ReactMarkdown>
    </Box>
  );
}